import { LandingPageConfig } from './landing-page.models';

export const MYLOCKER_LANDING_CONFIG: LandingPageConfig = {
  title: 'Lockers cerca de la Estación María Zambrano, Málaga',
  heroImage: {
    imageSmall: 'assets/landing/hero-malaga.jpg',
    imageMedium: 'assets/landing/hero-malaga.jpg',
    imageLarge: 'assets/landing/hero-malaga.jpg',
  },
  rrss: { 
    facebook: null, 
    instagram: null, 
    tiktok: null 
  },
  lockers: [
    /*{
        "id": 1,
        "code": "S",
        "urlLink": null,
        "dimensions": "300x400x200",
        "image": {
            "imageSmall": null,
            "imageMedium": null,
            "imageLarge": null
        },
        "literals": [
            {
                "key": "LANDING_PAGE_LOCKER_XL_DESCRIPTION",
                "value": "LANDING_PAGE_LOCKER_XL_DESCRIPTION"
            },
            {
                "key": "LANDING_PAGE_LOCKER_XL_NAME",
                "value": "LANDING_PAGE_LOCKER_XL_NAME"
            }
        ]
    },
    {
        "id": 1,
        "code": "XL",
        "urlLink": null,
        "dimensions": "300x400x200",
        "image": {
            "imageSmall": null,
            "imageMedium": null,
            "imageLarge": null
        },
        "literals": [
            {
                "key": "LANDING_PAGE_LOCKER_XL_DESCRIPTION",
                "value": "LANDING_PAGE_LOCKER_XL_DESCRIPTION"
            },
            {
                "key": "LANDING_PAGE_LOCKER_XL_NAME",
                "value": "LANDING_PAGE_LOCKER_XL_NAME"
            }
        ]
    },
    {
      "id": 1,
      "code": "XL",
      "urlLink": null,
      "dimensions": "300x400x200",
      "image": {
          "imageSmall": null,
          "imageMedium": null,
          "imageLarge": null
      },
      "literals": [
          {
              "key": "LANDING_PAGE_LOCKER_XL_DESCRIPTION",
              "value": "LANDING_PAGE_LOCKER_XL_DESCRIPTION"
          },
          {
              "key": "LANDING_PAGE_LOCKER_XL_NAME",
              "value": "LANDING_PAGE_LOCKER_XL_NAME"
          }
      ]
  },*/
  ],
  reviews: [/*
    {
      id: 'ana-m',
      author: 'Ana M.',
      text: 'Todo perfecto. Muy cerca de la estación y súper fácil de usar. Repetiré sin duda.',
      rating: 5,
    },
    {
      id: 'carlos-r',
      author: 'Carlos R.',
      text: 'Una solución comodísima para disfrutar de Málaga sin cargar con las maletas.',
      rating: 5,
    },
    {
      id: 'laura-g',
      author: 'Laura G.',
      text: 'Seguro, rápido y con un personal muy amable.',
      rating: 5,
    },*/
  ],
  nearbyPlaces: [/*
    { id: 'alcazaba', name: 'Alcazaba de Málaga', walkingTime: 'A 15 min', image: 'assets/landing/near-alcazaba.jpg' },
    { id: 'catedral', name: 'Catedral de Málaga', walkingTime: 'A 15 min', image: 'assets/landing/near-catedral.jpg' },
    { id: 'picasso', name: 'Museo Picasso', walkingTime: 'A 20 min', image: 'assets/landing/near-picasso.jpg' },
    { id: 'malagueta', name: 'Playa de la Malagueta', walkingTime: 'A 25 min', image: 'assets/landing/near-malagueta.jpg' },
    { id: 'puerto', name: 'Puerto de Málaga', walkingTime: 'A 20 min', image: 'assets/landing/near-puerto.jpg' },*/
  ],
  faqs: [/*
    {
      id: 'tiempo-reserva',
      question: '¿Cuánto tiempo puedo reservar un locker?',
      answer: 'Puedes reservarlo desde unas horas hasta varios días, según la disponibilidad del centro.',
    },
    {
      id: 'ubicacion',
      question: '¿Dónde se encuentran los lockers?',
      answer: 'Disponemos de ubicaciones en puntos estratégicos de Málaga, cerca de estaciones y zonas turísticas.',
    },
    {
      id: 'limite-peso',
      question: '¿Hay un límite de tamaño o peso en el equipaje?',
      answer: 'El límite depende del tamaño del locker elegido. Revisa las medidas antes de finalizar tu reserva.',
    },
    {
      id: 'metodos-pago',
      question: '¿Qué métodos de pago aceptan?',
      answer: 'Aceptamos las principales tarjetas y métodos de pago digitales compatibles con el proceso de reserva.',
    },
    {
      id: 'modificar-reserva',
      question: '¿Puedo modificar o cancelar mi reserva?',
      answer: 'Sí, siempre que las condiciones de tu reserva lo permitan. Consulta los detalles incluidos en la confirmación.',
    },
    {
      id: 'seguridad',
      question: '¿Es seguro dejar mi equipaje en los lockers?',
      answer: 'Los lockers están protegidos mediante acceso individual, sistemas de control y vigilancia de la instalación.',
    },*/
  ],
};
